import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-data-view-shell',
  standalone: true,
  template: `
    <section class="data-view-shell">
      @if (isLoading) {
        <ng-content select="[dataViewLoading]" />
      } @else if (hasError) {
        <ng-content select="[dataViewError]" />
      } @else if (isEmpty) {
        <ng-content select="[dataViewEmpty]" />
      } @else {
        <ng-content />
      }
    </section>
  `,
  styles: [`
    .data-view-shell {
      width: 100%;
      min-width: 0;
      display: block;
    }
  `],
})
export class DataViewShellComponent {
  @Input() public isLoading = false;
  @Input() public hasError = false;
  @Input() public isEmpty = false;
}

